import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { getSession } from '../../services/authService';
import AdminLayout from '../../layouts/AdminLayout';

class ProtectedRoute extends React.Component {
  state = { loading: true, user: null };

  componentDidMount() {
    getSession()
      .then(({ authenticated, user }) => this.setState({ loading: false, user: authenticated ? user : null }))
      .catch(() => this.setState({ loading: false, user: null }));
  }

  render() {
    const { component: Component, render: renderPage, ...rest } = this.props;
    const { loading, user } = this.state;

    return (
      <Route
        {...rest}
        render={(routeProps) => {
          if (loading) {
            return <div className="admin-loading">Vérification de la session…</div>;
          }
          if (!user) {
            return <Redirect to={{ pathname: '/admin/login', state: { from: routeProps.location } }} />;
          }
          const page = Component ? <Component {...routeProps} user={user} /> : renderPage(routeProps);
          return <AdminLayout user={user}>{page}</AdminLayout>;
        }}
      />
    );
  }
}

export default ProtectedRoute;
